<div class="PageContent">
    <div class="PageContentTitle">
        <i class="material-icons">settings</i>
        {{'MySettings' | translate}}
    </div>
    <div class="PageContentBody animated fadeIn">
        <div class="OneThirdColumn">

            <div class="ColumnTitle">
                <i class="material-icons">radio_button_checked</i>
                {{'GeneralInformation' | translate}}
            </div>

            <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'AccountSettingsPage.UserID' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.Id">
              </mat-form-field>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'Login.Username' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.UserName">
              </mat-form-field>
    
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'AccountSettingsPage.Email' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.Email">
              </mat-form-field>
    
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.parent.User.Phone">
              </mat-form-field>
    
              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'AccountSettingsPage.SecretToken' | translate }}</mat-label>
                <input matInput disabled [(ngModel)]="this.parent.User.Token">
              </mat-form-field>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'Name' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.parent.User.UIName">
              </mat-form-field>
              
        </div>

        <div class="TwoThirdsColumnWithGap" style="padding-right: 25px;">
            <div class="ColumnTitle">
                <i class="material-icons">person_search</i>
                {{'PresentationInformation' | translate}} {{this.parent.Company.Name}}
            </div>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'SkypeAccount' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.parent.User.UserManagementInfo.Skype">
              </mat-form-field>

              <mat-form-field class="fullWidth" appearance="outline">
                <mat-label>{{ 'Title' | translate }}</mat-label>
                <input matInput [(ngModel)]="this.parent.User.UserManagementInfo.Title">
              </mat-form-field>
             
              <mat-form-field appearance="outline" class="fullWidth">
                <mat-label>{{ 'EmployeeActivityAddress' | translate }}</mat-label>
                <mat-select name="UserPresentationInfoAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.parent.User.UserManagementInfo.WorkAddress">
                  <mat-option *ngFor="let a of this.parent.Company.Addresses" [value]="a">
                    {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;margin-bottom: 5%;">
                <mat-accordion>

                    <mat-expansion-panel disabled>
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ 'SMTP' | translate }}
                          </mat-panel-title>
                          <mat-panel-description>
                            
                          </mat-panel-description>
                          <mat-panel-description>
                            {{ 'Port' | translate }}
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                      </mat-expansion-panel>
            
                    <mat-expansion-panel *ngFor="let s of this.SMTPConfigs; index as i" (opened)="GetCompanySMTPEmails(s.ID); CurrenctSMTP = s;">
                      <mat-expansion-panel-header class="ExpandHeadder">
                        <mat-panel-title>
                          {{s.SMTPServer}}
                        </mat-panel-title>
                        <mat-panel-description>
                          
                        </mat-panel-description>
                        <mat-panel-description>
                          {{s.Port}}
                          </mat-panel-description>
                      </mat-expansion-panel-header>
            
                      <div style="margin-top: 20px;">
                        <div class="halfWidth">
                          <mat-form-field class="example-full-width halfWidth" appearance="outline">
                            <mat-label>{{ 'SMTP' | translate }}</mat-label>
                            <input disabled="true" matInput [(ngModel)]="s.SMTPServer">
                          </mat-form-field>

                          <mat-form-field class="example-full-width halfWidth" appearance="outline">
                            <mat-label>{{ 'Port' | translate }}</mat-label>
                            <input disabled="true" matInput [(ngModel)]="s.Port">
                          </mat-form-field>
                        </div>

                        <div class="halfWidth">
                          <mat-form-field appearance="outline" class="fullWidth">
                            <mat-label>{{ 'EmailAddresses' | translate }}</mat-label>
                            <mat-select name="UserPresentationInfoAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.parent.User.UserManagementInfo.EmailModel">
                              <mat-option *ngFor="let e of this.SMTPEmails" [value]="e">
                                {{e.Email}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <div class="fullWidthContainer">
                        
                      </div>

                       <div class="fullWidthContainer" *ngIf="loadingUser">
                        <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
                      </div>

                    </mat-expansion-panel>
                  </mat-accordion>
              </div>
        </div>

        <div class="fullWidthContainer SignatureModelContainer">
          <div class="OneThirdColumn" style="min-height: 400px;">
            
          </div>
          <div class="TwoThirdsColumnWithGap" style="padding-right: 25%;">
            <div class="ColumnTitle">
              <i class="material-icons">mark_email_read</i>
              {{'EmailSignature' | translate}}
          </div>

            <div [innerHTML]='this.parent.signature'>
            </div>
          </div>
        </div>
    </div>
    <div class="PageContentBodyCommands">
        <button mat-raised-button class="MainCommandButton" (click)="UpdateUser();">
            <i class="material-icons">save_alt</i>
            {{'Update' | translate}}
        </button>
    </div>
</div>
